var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _g2, _ellipse3, _path8, _path9, _path0, _g3, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _ellipse4, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceUnavailable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 394,
    viewBox: "0 0 394 394",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4824_37606",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 394,
    height: 394
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L393.511 0V393.511H0L0 0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4824_37606)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M402.468 362.413C411.959 343.631 384.833 249.719 196.754 249.719C60.9991 249.719 -1.30883 326.588 12.4662 365.544",
    fill: "url(#paint0_radial_4824_37606)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4824_37606",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 249,
    width: 395,
    height: 117
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M402.468 362.413C411.959 343.631 384.833 249.719 196.754 249.719C60.9991 249.719 -1.30883 326.588 12.4662 365.544",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4824_37606)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.671968,
    cx: 167.748,
    cy: 302.378,
    rx: 10.3435,
    ry: 5.74529,
    fill: "#8FBBDC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.451707,
    cx: 278.158,
    cy: 316.197,
    rx: 16.3197,
    ry: 8.96264,
    fill: "#86C1EE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.729957,
    cx: 87.5951,
    cy: 269.705,
    rx: 16.3197,
    ry: 8.96264,
    fill: "#6EA6D0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.716378,
    d: "M142.66 260.541C136.317 267.718 161.418 274.35 207.595 275.907C257.88 289.608 280.731 293.324 289.968 286.243C299.205 279.162 259.553 257.066 228.51 250.084C197.466 243.103 180.412 247.627 161.38 252.645C158.803 253.324 160.081 252.804 154.235 254.767C148.389 256.731 144.202 258.795 142.66 260.541Z",
    fill: "url(#paint1_linear_4824_37606)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M210.624 219.927C210.624 219.927 191.156 241.615 203.075 254.987C187.897 255.943 177.903 263.188 177.903 263.188L169.638 233.379L210.624 219.927Z",
    fill: "url(#paint2_linear_4824_37606)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.507 261.561C178.507 261.561 163.357 255.094 157.301 255.084C151.246 255.073 169.979 232.422 169.979 232.422L180.926 259.486L178.507 261.561Z",
    fill: "url(#paint3_linear_4824_37606)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5898 230.148C100.184 269.289 164.092 269.069 203.613 229.548C243.134 190.028 243.354 126.12 204.213 86.525L60.5898 230.148Z",
    fill: "url(#paint4_linear_4824_37606)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.842,
    cy: 159.628,
    rx: 22.4443,
    ry: 101.557,
    transform: "rotate(45 132.842 159.628)",
    fill: "url(#paint5_linear_4824_37606)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4824_37606",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 86,
    width: 148,
    height: 148
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.842,
    cy: 159.628,
    rx: 22.4443,
    ry: 101.557,
    transform: "rotate(45 132.842 159.628)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4824_37606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.088 166.087L120.925 146.256L136.814 187.444",
    fill: "url(#paint6_linear_4824_37606)"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.965,
    cy: 142.903,
    rx: 14.5082,
    ry: 14.5585,
    transform: "rotate(-45 116.965 142.903)",
    fill: "url(#paint7_linear_4824_37606)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8467 131.371C71.5573 131.372 72.1886 131.057 72.6616 130.584C73.2135 130.032 73.4886 129.283 73.4478 128.454C73.0008 120.596 75.9496 112.901 81.5077 107.343C86.987 101.864 94.6024 98.9149 102.381 99.2829C103.921 99.3248 105.262 98.1425 105.299 96.6027C105.336 95.063 104.149 93.7186 102.609 93.6766C93.2904 93.2667 84.136 96.8054 77.553 103.388C70.8911 110.05 67.3921 119.323 67.8811 128.721C68.0021 130.261 69.307 131.487 70.8467 131.371ZM88.085 136.555C88.7688 136.457 89.3662 136.195 89.7961 135.765C90.3433 135.218 90.6785 134.38 90.5672 133.487C90.0217 129.346 91.3404 125.349 94.1545 122.535C96.9296 119.76 100.846 118.438 104.903 118.9C106.447 119.114 107.823 117.989 107.89 116.415C108 114.883 106.778 113.427 105.196 113.251C99.4746 112.612 93.9202 114.483 90.0117 118.392C85.9859 122.418 84.1168 128.053 84.8821 133.9C85.0965 135.443 86.511 136.623 88.085 136.555Z",
    fill: "url(#paint8_linear_4824_37606)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.243 127.981C50.772 128.452 50.1446 128.767 49.4003 128.807C47.8724 128.849 46.6211 127.677 46.5065 126.149C46.0241 112.243 51.4171 98.6396 61.2687 88.7879C66.244 83.8126 72.0498 80.0053 78.3765 77.5063C78.8728 77.2486 83.1106 76.6504 83.7193 78.4681C84.328 80.2859 80.2707 82.7709 80.2707 82.7709C74.7066 84.9952 69.5984 88.3561 65.2176 92.7369C56.465 101.49 51.7016 113.603 52.1086 126.021C52.0682 126.687 51.7533 127.471 51.243 127.981Z",
    fill: "url(#paint9_linear_4824_37606)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4824_37606",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 77,
    width: 38,
    height: 52
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M51.243 127.981C50.772 128.452 50.1446 128.767 49.4003 128.807C47.8724 128.849 46.6211 127.677 46.5065 126.149C46.0241 112.243 51.4171 98.6396 61.2687 88.7879C66.244 83.8126 72.0498 80.0053 78.3765 77.5063C78.8728 77.2486 83.1106 76.6504 83.7193 78.4681C84.328 80.2859 80.2707 82.7709 80.2707 82.7709C74.7066 84.9952 69.5984 88.3561 65.2176 92.7369C56.465 101.49 51.7016 113.603 52.1086 126.021C52.0682 126.687 51.7533 127.471 51.243 127.981Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4824_37606)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.895 70.6024C105.061 69.768 103.708 69.768 102.874 70.6024L97.347 76.1291L91.7976 70.5796C90.9632 69.7452 89.6103 69.7452 88.7758 70.5796C87.9414 71.4141 87.9414 72.767 88.7758 73.6014L94.3253 79.1508L88.7721 84.704C87.9376 85.5385 87.9376 86.8914 88.7721 87.7258C89.6065 88.5602 90.9594 88.5602 91.7938 87.7258L97.347 82.1726L102.877 87.703C103.712 88.5374 105.065 88.5374 105.899 87.703C106.734 86.8686 106.734 85.5157 105.899 84.6812L100.369 79.1508L105.895 73.6242C106.73 72.7898 106.73 71.4369 105.895 70.6024Z",
    fill: "#FFA9A9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M261.698 227.508C261.698 227.508 260.701 230.418 260.701 232.465C259.703 250.281 262.176 281.953 262.176 281.953H266.015L271.682 235.621L279.364 281.953H283.141C283.141 281.953 283.639 251.271 282.143 232.465C282.143 230.44 281.273 228.498 281.273 228.498L261.698 227.508Z",
    fill: "#34363D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M255.215 202.916L250.366 199.484L250.413 196.81L262.732 189.738L265.797 186.129L270.352 183.237L270.656 183.737L267.275 187.145L265.937 187.318C265.937 187.318 265.911 187.868 265.911 188.803C265.911 189.738 265.207 190.771 265.207 190.771L255.547 197.889L257.628 198.926L255.215 202.916Z",
    fill: "#FFE9E9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M282.639 209.816L286.461 214.288L288.289 215.262L302.585 202.328L301.996 198.43L288.289 209.816L285.132 206.911L282.639 209.816Z",
    fill: "#FFE9E9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M302.2 202.392L308.337 200.293L309.565 199.085V196.669C309.565 196.669 308.951 195.461 308.337 195.461C307.723 195.461 302.2 197.877 302.2 197.877C302.2 197.877 301.586 199.689 301.586 200.293C301.586 200.897 302.2 202.392 302.2 202.392Z",
    fill: "#FFE9E9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M304.571 189.516H308.57C309.118 189.516 309.562 189.96 309.562 190.508V200.405C309.562 200.953 309.118 201.397 308.57 201.397H304.571C304.022 201.397 303.578 200.953 303.578 200.405V190.508C303.578 189.96 304.022 189.516 304.571 189.516Z",
    fill: "#E9E9E9",
    stroke: "#AFAFAF",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M302.229 195.631C302.229 195.631 304.803 194.477 305.447 194.477C306.09 194.477 303.516 196.952 303.516 196.952C303.516 196.952 303.516 199.427 302.229 199.427C300.943 199.427 302.229 195.631 302.229 195.631Z",
    fill: "#FFE9E9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M286.832 206.364L282.868 211.314L280.037 208.707C280.037 208.707 281.215 216.402 281.736 220.226C282.256 224.049 281.736 230.315 281.736 230.315C281.736 230.315 275.041 231.45 270.976 231.75C266.911 232.049 261.127 230.214 261.127 230.214C261.127 230.214 259.508 218.245 261.127 206.182L254.218 203.643L257.21 198.078C257.21 198.078 259.508 198.937 262.197 199.222C264.886 199.506 267.184 199.222 267.184 199.222L274.664 198.442C274.664 198.442 279.531 198.693 280.648 199.798C281.764 200.902 286.832 206.364 286.832 206.364Z",
    fill: "#E58A7B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.852 192.992H268.633V199.052V199.057H268.636C268.715 199.18 270.321 201.683 270.321 202.523C270.321 203.368 272.756 199.216 272.85 199.057H272.852L272.852 199.052L272.852 192.992Z",
    fill: "#FECECD"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.498,
    cy: 192.059,
    rx: 3.79082,
    ry: 5.90267,
    fill: "#FFE9E9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.338 192.714C266.642 191.589 266.642 189.108 267.248 189.027C267.855 188.946 269.068 189.416 270.281 188.504C270.887 188.004 271.191 187.941 271.191 187.69C274.223 188.289 272.41 190.095 273.92 192.086C274.078 192.294 274.527 192.086 274.527 192.086C274.527 192.086 274.527 187.185 274.223 186.748C273.92 186.311 272.707 184.55 272.101 185.806C272.101 185.178 270.887 184.53 269.674 185.011C268.461 185.492 266.642 186.434 266.338 187.69C266.035 188.946 265.732 191.458 266.338 192.714Z",
    fill: "#513450"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M263.018 281.609L261.798 283.258C261.086 284.221 260.701 285.387 260.701 286.585C260.701 286.66 260.762 286.721 260.838 286.721H266.561C266.879 286.721 267.137 286.463 267.137 286.145C267.137 284.842 266.843 283.556 266.276 282.383L265.902 281.609H263.018Z",
    fill: "#677285"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M282.772 281.609L283.991 283.258C284.704 284.221 285.088 285.387 285.088 286.585C285.088 286.66 285.027 286.721 284.951 286.721H279.229C278.91 286.721 278.652 286.463 278.652 286.145C278.652 284.842 278.946 283.556 279.513 282.383L279.887 281.609H282.772Z",
    fill: "#677285"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4824_37606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(181.873 359.72) rotate(-90.2558) scale(137.178 1432.69)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A0E0",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353168,
    stopColor: "#7CACE5",
    stopOpacity: 0.513472
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78199,
    stopColor: "#85BBEB",
    stopOpacity: 0.845525
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FAAD6",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4824_37606",
    x1: 450.54,
    y1: 279.866,
    x2: 444.394,
    y2: 174.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C65B0",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4824_37606",
    x1: 161.9,
    y1: 245.146,
    x2: 195.488,
    y2: 259.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4824_37606",
    x1: 165.21,
    y1: 266.784,
    x2: 183.492,
    y2: 251.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4824_37606",
    x1: 104.015,
    y1: 297.606,
    x2: 257.969,
    y2: 187.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4824_37606",
    x1: 122.635,
    y1: -1.41581,
    x2: 32.5332,
    y2: 32.5799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6ECF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4824_37606",
    x1: 128.931,
    y1: 182.595,
    x2: 153.755,
    y2: 163.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4824_37606",
    x1: 97.1251,
    y1: 138.398,
    x2: 114.911,
    y2: 161.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7DBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4824_37606",
    x1: 141.485,
    y1: 80.0114,
    x2: 92.0965,
    y2: 55.2694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4824_37606",
    x1: 121.877,
    y1: 54.6904,
    x2: 91.1026,
    y2: 33.3619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceUnavailable);
export default __webpack_public_path__ + "static/media/ServiceUnavailable.6c4148275bbfba4406620c64c9d5f576.svg";
export { ForwardRef as ReactComponent };